import { render, staticRenderFns } from "./PurchaseHistoryCard.vue?vue&type=template&id=78644357&"
import script from "./PurchaseHistoryCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseHistoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports